module.exports = __webpack_public_path__ + "static/media/ic-monitor.d7936fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-monitor.svg
// module id = 644
// module chunks = 14